.k7{right:0.25rem;}